/****************************************************************************
 * COPYRIGHT (c) 2024 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/
export const FETCH_PORTFOLIO_CONTENTS_REQUEST = "FETCH_PORTFOLIO_CONTENTS_REQUEST";
export const FETCH_PORTFOLIO_CONTENTS_SUCCESS = "FETCH_PORTFOLIO_CONTENTS_SUCCESS";
export const FETCH_PORTFOLIO_CONTENTS_FAILURE = "FETCH_PORTFOLIO_CONTENTS_FAILURE";